import { useEffect, useState } from 'react'
import axios from 'axios';

const CategoryBar = ({ getAllProducts, getDiscountProducts, getProductsFromCategory }) => {
  const { REACT_APP_API_URL } = process.env;
  const [categories, setCategories] = useState([])

  useEffect(() => {
    axios.get(`${REACT_APP_API_URL}/get-categories`).then((result) => {
      setCategories(result.data);
    })
  }, [REACT_APP_API_URL])

  return (
    <div className="categories" style={{ flex: 1 }}>
      <div className="container">
        <h3>Categories</h3>
        <div className="category-fields">
          <button onClick={() => getAllProducts()}>Everything</button>
          <button onClick={() => getDiscountProducts()}>Sale items</button>
          {categories.map(cat => {
            return (
              <button onClick={() => getProductsFromCategory(cat.id)} key={cat.id}>{cat.category_name}</button>
            )
          })}
        </div>
      </div>
    </div>
  )
}

export default CategoryBar